interface FormatUserNameInput {
  firstName?: string | null
  lastName?: string | null
  name?: string | null
}

export const formatUserName = (user?: FormatUserNameInput | null, isAbbreviated = false): string => {
  if (!user) return ""

  const { firstName, lastName, name } = user
  if (!firstName || !lastName) return name ?? ""

  return isAbbreviated ? `${firstName[0]}. ${lastName}` : `${firstName} ${lastName}`
}
